import { logger } from "../utils/utils";
import api from "./apis/api";

class ProofingService {
  createProofing(payload) {
    logger("ProofingService", "createProofing");
    return api.proofing.createProofing(payload);
  }

  updateProofing(payload) {
    logger("ProofingService", "updateProofing");
    return api.proofing.updateProofing(payload?.proofingId, payload?.payload);
  }

  getProofingList(payload) {
    logger("ProofingService", "getProofingList");
    return api.proofing.getProofingList(payload);
  }

  sendToProofing(payload) {
    logger("ProofingService", "sendToProofing");
    return api.proofing.sendToProofingApi(payload);
  }

  getSpiritListAssociateProofing(payload) {
    logger("ProofingService", "getSpiritListAssociateProofing");
    return api.proofing.getSpiritListAssociateProofing(payload);
  }

  unlinkSpiritWithProofing(payload) {
    logger("ProofingService", "unlinkSpiritWithProofing");
    return api.proofing.unlinkSpiritWithProofing(payload);
  }

  deleteProofing(subLogId) {
    logger("ProofingService", "deleteProofing");
    return api.proofing.deleteProofing(subLogId);
  }
}

export default new ProofingService();
